import React from 'react'
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { reactPlugin } from '../../config/appInsights'

const AppInsightsContextProvider = ({ children }) => {
  return <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>
}

export default AppInsightsContextProvider
